import {
  CHECK_LOGIN,
  LOGIN_USER_SUCCESSFUL,
  LOGIN_USER_SUCCESSFUL_WITH_QR_CODE,
  LOGIN_USER_SUCCESSFUL_WITH_VERIFICATION,
  VERIFY_TOTP,
  VERIFY_TOTP_SUCCESSFUL,
  API_ERROR,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  FORCE_LOGOUT,
  CLEAR_ALL_LOGIN_MESSAGES_SUCCESSFUL,
} from "./actionTypes";

const initialState = {
  loginError: "",
  message: null,
  loading: false,
  user: null,
  mfaSetup: null,
  verification: null,
  stage: null,
};

const login = (state = initialState, action) => {
  switch (action.type) {
    case CHECK_LOGIN:
      state = {
        ...state,
        loading: true,
        loginError: null,
        message: null,
      };
      break;
    case VERIFY_TOTP:
      state = {
        ...state,
        loading: true,
        loginError: null,
        message: null,
      };
      break;
    case LOGIN_USER_SUCCESSFUL_WITH_QR_CODE:
      state = {
        ...state,
        loading: false,
        mfaSetup: action.payload,
        stage: "MFASETUP",
      };
      break;
    case LOGIN_USER_SUCCESSFUL_WITH_VERIFICATION:
      state = {
        ...state,
        loading: false,
        verification: action.payload,
        stage: "VERIFICATION",
      };
      break;
    case LOGIN_USER_SUCCESSFUL:
      state = {
        ...state,
        loading: false,
        user: action.payload,
        stage: "AUTHENTICATED",
        mfaSetup: null,
        verification: null,
      };
      break;
    case VERIFY_TOTP_SUCCESSFUL:
      state = {
        ...state,
        loading: false,
        message: action.payload,
        stage: null,
        mfaSetup: null,
        verification: null,
      };
      break;

    case LOGOUT_USER:
      state = { ...state };
      break;
    case FORCE_LOGOUT:
      state = { ...state };
      break;
    case LOGOUT_USER_SUCCESS:
      state = { ...state };
      break;

    case API_ERROR:
      console.log("API_ERROR :: ", action.payload.message)
      state = {
        ...state,
        loading: false,
        loginError: action.payload.message
      };
      break;
    case CLEAR_ALL_LOGIN_MESSAGES_SUCCESSFUL:
        state = {
          ...state,
          loginError: null,
          message: null,
          loading: false,
        };
        break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default login;
